//
import { BranchOfficeModel } from '@/models'

/**
 *
 */
const fetchAll = async function() {
    //
    try {
        //
        const branchOffice = await BranchOfficeModel.params({
            get_all_results: true,
        }).get()

        //
        return branchOffice.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchAll
